import { useMemo } from "react";

import { flattenSchemaOptions } from "ServerData/EventSchema/Utils/eventSchemaUtils";

import {
    UpdateContactForm,
    FIELD_TYPE_STRING,
    FIELD_TYPE_NUMBER,
    FIELD_TYPE_BOOLEAN,
    FIELD_TYPE_OBJECT,
    FIELD_TYPE_DATE,
    FIELD_TYPE_LIST,
} from "../../../../constants";
import { UpdateContactAttributeFormPanel } from "../../../Shared/Components/UpdateContactAttributeFormPanel/UpdateContactAttributeFormPanel";
import { useUpdateContactPanelItems } from "../../../Shared/Hooks/useUpdateContactPanelItems/useUpdateContactPanelItems";

import type { EventSchemaOptionEntry } from "ServerData/EventSchema/eventSchemaTypes";

const ATTR_NAME = "Contact Attribute";
const TYPE_LABEL = "Data Type";
const CUSTOM_PROP_CREATE = "Create Attribute";
const CUSTOM_PROP_VALUE_PREPREND = "customProperties.";

export interface OptionsData extends Array<any> {
    value?: string;
}
const LABEL_ATTR = "Attribute Value";
const LABEL_NUMBER = "Enter Integer or Decimal";
const LABEL_OBJECT = "Attribute Value in JSON";

const getLexLabel = (fieldType: string) => {
    switch (fieldType) {
        case FIELD_TYPE_NUMBER:
            return LABEL_NUMBER;
        case FIELD_TYPE_STRING:
            return LABEL_ATTR;
        case FIELD_TYPE_BOOLEAN:
            return LABEL_ATTR;
        case FIELD_TYPE_DATE:
            return LABEL_ATTR;
        case FIELD_TYPE_OBJECT:
            return LABEL_OBJECT;
        case FIELD_TYPE_LIST:
            return LABEL_OBJECT;
        default:
            return "";
    }
};

type UpdateProfileFormItemsProps = {
    id: string;
    contactAttributes: EventSchemaOptionEntry;
    // index: number; // actually comes from  //BaseContentProps figure out how to make the types work
};

export function UpdateProfileFormItems({ id, contactAttributes }: UpdateProfileFormItemsProps): JSX.Element {
    const originalOptions = useMemo(() => {
        return flattenSchemaOptions(contactAttributes, "", false);
    }, [contactAttributes]);

    const profileAttrName = useMemo(() => {
        return [UpdateContactForm.profileListName, id, UpdateContactForm.profileAttrName];
    }, [id]);
    const profileAttrValueName = useMemo(() => {
        return [UpdateContactForm.profileListName, id, UpdateContactForm.profileAttrValue];
    }, [id]);
    const profileAttrTypeName = useMemo(() => {
        return [UpdateContactForm.profileListName, id, UpdateContactForm.profileAttrType];
    }, [id]);

    const { handleFieldChange, handleValueChange, handleTypeChange } = useUpdateContactPanelItems({
        contactAttributes,
        id,
        listNameKey: UpdateContactForm.profileListName,
        attributeNameKey: UpdateContactForm.profileAttrName,
        typeNameKey: UpdateContactForm.profileAttrType,
        valueNameKey: UpdateContactForm.profileAttrValue,
        selectionName: profileAttrName,
        valuesName: profileAttrValueName,
        typeName: profileAttrTypeName,
    });

    return (
        <UpdateContactAttributeFormPanel
            attrNameLabel={ATTR_NAME}
            attrNameFormName={profileAttrName}
            attrTypeLabel={TYPE_LABEL}
            attrTypeFormName={profileAttrTypeName}
            attrValueFormName={profileAttrValueName}
            createNewText={CUSTOM_PROP_CREATE}
            originalOptions={originalOptions}
            createNewPrefix={CUSTOM_PROP_VALUE_PREPREND}
            handleFieldChange={handleFieldChange}
            handleValueChange={handleValueChange}
            handleTypeChange={handleTypeChange}
            getValueLabel={getLexLabel}
        ></UpdateContactAttributeFormPanel>
    );
}
